import {StyleSheet, PixelRatio} from 'react-native';
import {getScreenSize} from "../../../../common/utils";

export default StyleSheet.create({
    cheapImage:{
        height: getScreenSize().width / 375 * 160,
        width: '100%',
    },
    cheapSection:{
        marginTop: -100
    },
    rankRuleRow: {
        height: 0,
        marginLeft: 16,
        marginRight: 16,
    },
    rankRuleBtn: {
        position: 'absolute',
        bottom: 0,
        flexDirection: 'row',
        alignItems: 'center',
    },
    rankRuleText: {
        fontFamily: "PingFangSC-Regular",
        fontSize: 11,
        color: "#999999",
    },
    rankRuleIcon: {
        marginTop: 1.5,
    },
    priceCardBlock:{
        flexDirection:'row',
        marginLeft: 8,
        marginRight: 16,
    },
    moreField:{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginVertical: 16
    },
    moreIcon:{
        height: 17,
        lineHeight: 17
    },
    moreText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 12,
        color: "#999999",
    }
});